import { Error404Image } from '../../assets'
import './error-404.scss'

const Error404: React.FC = () => {
  return (
    <div className="flex flex-col w-full gap-4 items-center justify-center px-4 md:px-16 py-8 md:py-16 error-page">
      <img
        src={Error404Image}
        alt="A bee with quesiton mark symbols above its head, indicating that its lost"
        className="max-w-[12rem]"
      />
      <div className="text-justify hyphenate text-xl font-medium">
        Oops! Something went wrong.
      </div>
      <div className="text-center hyphenate text-base">
        We apologise for the inconvenience, please return to the home page.
      </div>
      <button className="bg-component-green rounded-lg border-none text-white p-4">
        Go to Home Page
      </button>
    </div>
  )
}

export default Error404
